import { AnimationControlsContext } from '@shared/contexts/AnimationControlsContext';
import { AnimationControls } from '@shared/models/animationControls';
import { useContext } from 'react';

export default function useAnimationControls(): AnimationControls {
  return useContext(AnimationControlsContext);
}
